"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsives = void 0;
var screens_1 = require("./screens");
exports.responsives = {
    xsMax: "@media (max-width: " + screens_1.screens.xsMax + "px)",
    xsPlus: "@media (min-width: " + screens_1.screens.xsMin + "px)",
    smMax: "@media (max-width: " + screens_1.screens.smMax + "px)",
    smPlus: "@media (min-width: " + screens_1.screens.smMin + "px)",
    mdMax: "@media (max-width: " + screens_1.screens.mdMax + "px)",
    mdPlus: "@media (min-width: " + screens_1.screens.mdMin + "px)",
    lgMax: "@media (max-width: " + screens_1.screens.lgMax + "px)",
    lgPlus: "@media (min-width: " + screens_1.screens.lgMin + "px)",
};
//# sourceMappingURL=responsives.js.map